<ng-container *rxLet="state$ as dialogState" class="personal-details-email-update-dlg-container">
  <h1 class="text-18 mb-0" data-test-id="personal-details-email-update-header" mat-dialog-title>
    {{ MODAL_TEXTS[dialogState.CurrentDialogState].header }}
    <button
      (click)="closeDialog()"
      class="close-btn"
      data-test-id="personal-details-email-update-dlg-close-button"
      isIconButton="true"
      mat-button
      type="button"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </h1>

  <div class="flex flex-col flex-start-start gap-16" mat-dialog-content>
    <div>
      <p class="m-0" data-test-id="personal-details-email-update-description">
        {{ MODAL_TEXTS[dialogState.CurrentDialogState].description }}
      </p>
    </div>
    <div class="forms-container w-full">
      @switch (dialogState.CurrentDialogState) {
        @case (EmailUpdateDialogStates.UpdateEmail) {
          <form [formGroup]="emailChangeForm" class="w-full">
            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
              <mat-label data-test-id="consultant-business-details-inlineEdit-form-field-label">
                Add your new email
              </mat-label>
              <input
                [attr.maxlength]="MAX_EMAIL_LENGTH"
                data-test-id="personal-details-email-update-dlg-email-input"
                formControlName="email"
                matInput
                name="email"
                placeholder="New email"
                type="email"
              />
            </mat-form-field>
            <validation-messages
              [field]="emailChangeForm.get('email')"
              [messages]="errors.requestEmailUpdate.errors"
              [texts]="errors.requestEmailUpdate.messages"
              class="error"
            ></validation-messages>
          </form>
        }
        @case (EmailUpdateDialogStates.VerifyCode) {
          <form [formGroup]="verificationCodeForm" class="w-full">
            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
              <mat-label data-test-id="personal-details-email-update-dlg-code-label">Code</mat-label>
              <input
                [attr.maxlength]="MAX_EMAIL_LENGTH"
                data-test-id="personal-details-email-update-dlg-code-input"
                formControlName="code"
                matInput
                name="code"
                placeholder="Code"
                type="text"
              />
            </mat-form-field>
            <validation-messages
              [field]="verificationCodeForm.get('code')"
              [messages]="errors.codeVerification.errors"
              [texts]="errors.codeVerification.messages"
              class="error"
            ></validation-messages>

            <div class="pt-16 flex flex-col">
              <div class="flex gap-9">
                Didn't got the code?
                <button
                  [disabled]="dialogState.ResendTimer > 0 || dialogState.GenerateCode?.Loading"
                  data-test-id="personal-details-email-update-dlg-resend-link"
                  (click)="resendCode()"
                  color="accent"
                  mat-button
                  type="button"
                >
                  Resend code {{ dialogState.ResendTimer > 0 ? '(' + dialogState.ResendTimer + 's)' : '' }}
                </button>
              </div>
              <mat-error
                *ngIf="dialogState.GenerateCode?.Error"
                class="error"
                data-test-id="personal-details-email-update-dlg-resend-error"
              >
                {{ errors.generateCode.messages[dialogState.GenerateCode.Status] }}
              </mat-error>
            </div>
          </form>
        }
      }
    </div>
  </div>

  <div mat-dialog-actions>
    <button
      [loading]="dialogState.RequestUpdate?.Loading || dialogState.CodeVerification?.Loading"
      (click)="confirmAction()"
      class="small-button personal-details-email-update-dlg-confirm-btn"
      color="accent"
      data-test-id="personal-details-email-update-dlg-confirm-button"
      mat-stroked-button
      type="button"
    >
      {{ MODAL_TEXTS[dialogState.CurrentDialogState].confirmBtnText }}
    </button>
    <button
      (click)="closeDialog()"
      cdkFocusInitial
      class="small-button personal-details-email-update-dlg-cancel-btn"
      color="accent"
      data-test-id="personal-details-email-update-dlg-cancel-button"
      mat-button
      type="button"
    >
      {{ MODAL_TEXTS[dialogState.CurrentDialogState].cancelBtnText }}
    </button>
  </div>
</ng-container>
